<template>
    <div class="flex items-center text-[14px] leading-loose text-[#141430]">
        <div class="flex flex-1 justify-start items-center">
            <p :class="{'font-bold': emphasized}">{{ name }}</p>

            <v-tooltip v-if="tooltipContent" location="right">
                <template v-slot:activator="{ props }">
                    <img
                        v-bind="props"
                        src="/images/campaigns/tooltip-icon.svg"
                        class="cursor-pointer ml-2 -mt-[1.5px]"
                        alt="Tooltip icon"
                    />
                </template>

                <span>{{ tooltipContent }}</span>
            </v-tooltip>
        </div>

        <p
            class="text-[14px] ml-4 leading-loose"
            :class="{'font-bold': emphasized || coloredPrice, 'text-[#00A842]': coloredPrice, 'text-[#141430]': !coloredPrice}"
        >
            {{ $numberHelper.formatMoneyObject(priceValue, true) }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        tooltipContent: {
            type: String,
            required: false,
            default: null,
        },
        priceValue: {
            type: Number,
            required: true,
        },
        emphasized: {
            type: Boolean,
            required: false,
            default: false,
        },
        coloredPrice: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>
